import { useState } from "react";

//EX 22-09-2026 (unificacion alta/edicion, fase 3 - paso 3b-1): el estado que el formulario del
//Tab 1 comparte entre el alta y la edicion.
//
//Medido con el AST antes de escribir esto: los dos contenedores tenian 18 useState cada uno y 16
//comunes POR NOMBRE (mismos estados, mismos setters). Los iniciales NO viven aca: el hook los
//recibe por parametro, porque 10 de los 16 tienen inicial distinto entre flujos (no solo 5: los
//cuatro objetos grandes --inputs, inputsTram, inputsCSP, formRows, boletos, tramites-- se siembran
//desde la base en la edicion, y ademas inputs tiene 33 claves en el alta y 32 en la edicion).
//Tampoco se pueden compartir como valor por defecto: dependen de locales de cada contenedor
//(_fechaHoy y compania).
//
//Devuelve los MISMOS nombres, asi que el resto de cada contenedor no cambio: en los dos
//contenedores se reemplazaron 16 declaraciones por una llamada a este hook.
//
//Quedan afuera, por ser de un solo flujo: estadoExp y result (alta), inputs_send y openCatastro
//(edicion).
//
//OJO con el orden de los hooks si se toca: la llamada tiene que quedar INCONDICIONAL y antes del
//primer uso de cualquiera de los 16 estados evaluado en el render (si no, TDZ). Los iniciales
//referencian locales de cada contenedor, asi que la llamada va despues de esos calculos: ese
//punto lo mide la transformacion, no se elige a mano.
const useExpedienteForm = (iniciales) => {
	const [show, setShow] = useState(iniciales.show);
	const [geomB, setGeomB] = useState(iniciales.geomB);
	const [censos, setCensos] = useState(iniciales.censos);
	const [boletos, setBoletos] = useState(iniciales.boletos);
	const [tramites, setTramites] = useState(iniciales.tramites);
	const [observaciones_censo, setObservacionesCenso] = useState(iniciales.observaciones_censo);
	const [inputs, setInputs] = useState(iniciales.inputs);
	const [formRows, setFormRows] = useState(iniciales.formRows);
	const [inputsTram, setInputsTram] = useState(iniciales.inputsTram);
	const [inputsCSP, setInputsCSP] = useState(iniciales.inputsCSP);
	const [errorD, setErrorD] = useState(iniciales.errorD);
	const [errorCSP, setErrorCSP] = useState(iniciales.errorCSP);
	const [resultError, setResultError] = useState(iniciales.resultError);
	const [openExpediente, setOpenE] = useState(iniciales.openExpediente);
	const [openTramite, setOpenT] = useState(iniciales.openTramite);
	const [openPestaña3, setOpenP3] = useState(iniciales.openPestaña3);

	return {
		show, setShow,
		geomB, setGeomB,
		censos, setCensos,
		boletos, setBoletos,
		tramites, setTramites,
		observaciones_censo, setObservacionesCenso,
		inputs, setInputs,
		formRows, setFormRows,
		inputsTram, setInputsTram,
		inputsCSP, setInputsCSP,
		errorD, setErrorD,
		errorCSP, setErrorCSP,
		resultError, setResultError,
		openExpediente, setOpenE,
		openTramite, setOpenT,
		openPestaña3, setOpenP3,
	};
};

export default useExpedienteForm;
